module.exports = __webpack_public_path__ + "static/img/30.87ac162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/30.png
// module id = x4SS
// module chunks = 1